/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RoutePlanFeedbackSourceEnum =
  (typeof RoutePlanFeedbackSourceEnum)[keyof typeof RoutePlanFeedbackSourceEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoutePlanFeedbackSourceEnum = {
  Toast: 0,
  Page: 1,
  Button: 2,
} as const;
